import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PDND_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { PDNDNotificationState } from 'shell/models/pdnd-notification';
import { ItemVM } from 'shell/view-models/item';

interface NotificationStateListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
}

const NotificationStateListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Stato Notifica',
}: NotificationStateListProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseListPayloadQuarkus<PDNDNotificationState>, Array<ItemVM>>(
    `${__PDND_API_URL__}/stato/list`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (
        response: AxiosResponse<HttpResponseListPayloadQuarkus<PDNDNotificationState>>
      ) => {
        const { data } = response;
        return data?.payload?.map((item) => ({
          id: item.codiceStato || '',
          value: item.descrizioneStatoIt || '',
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="notification-state-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="notification-state-list-label"
        id="notification-state-list"
        name="notification-state-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list.data as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

NotificationStateListComponent.displayName = 'notification state list component';

const NotificationStateList = memo(NotificationStateListComponent);

export default NotificationStateList as typeof NotificationStateListComponent;
